import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookMarked, ArrowRight } from "lucide-react";
import { fetchSourcesCount } from "@/lib/api";

export default function SourcesStrip() {
  const [count, setCount] = useState(null);
  useEffect(() => { fetchSourcesCount().then((d) => setCount(d.count)).catch(() => {}); }, []);
  if (!count) return null;
  return (
    <Link to="/sources" data-testid="home-sources-strip" className="group block border-y border-line bg-[var(--surface)]">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-5 py-4 text-center">
        <BookMarked className="h-4 w-4 text-[var(--saffron)]" />
        <span className="text-sm text-ink-2"><b className="text-ink">{count}+ traditional sources</b> referenced across Dharmartha — grounded in authentic śāstra.</span>
        <span className="inline-flex items-center gap-1 text-sm font-medium text-[var(--saffron)] transition-all group-hover:gap-2">View all <ArrowRight className="h-3.5 w-3.5" /></span>
      </div>
    </Link>
  );
}
